import useFetch from '../../hooks/useFetch'
import { useState } from 'react'
import { urlApi } from '../../config'
import Alert from '../Alert'
import LobbyActionResult, { cancelSummaryLines } from './LobbyActionResult'

export default function CancelLobby({ lobby }) {
  const [alert, setAlert] = useState(true)
  const { loading, responseOk, data } = useFetch(`${urlApi}/admin/lobbies/cancel/${lobby._id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  return (
    <Alert
      visible={alert}
      onClose={() => {
        if (!responseOk) {
          setAlert(false)
        } else {
          setAlert(false)
          lobby.cancelled = true
        }
      }}
      hideButton={loading}
    >
      <LobbyActionResult
        loading={loading}
        ok={responseOk}
        title='Viaje cancelado.'
        lines={cancelSummaryLines(data?.refund_summary)}
      />
    </Alert>
  )
}
